import React, { ReactElement } from 'react';
import ThumbnailBlock from '../assets/images/Thumbnail-Block.png';
import { ClockIcon, Contact, Link1, ImageIcon, OrderLink, Booking } from '@menuzen/icon/build/outline';
import { SerializedNode } from '@mnz/builder';

export const MODAL = {
    SITE_ACTION: 'SITE_ACTION',
    SITE_SHARE: 'SITE_SHARE',
    SITE_DELETE: 'SITE_DELETE',
    SITE_SETTING: 'SITE_SETTING',
};

export const VALIDATION = {
    NAME_LENGTH: 50,
    DESCRIPTION_LENGTH: 300,
    MIN_PATH_LENGTH: 3,
    MAX_PATH_LENGTH: 30,
};

export interface Block {
    title: string;
    subTitle?: string;
    image?: string;
    icon?: ReactElement;
    isReady?: boolean;
    forGrowAccount?: boolean;
    nodeData: SerializedNode;
    name: string;
    limits: number;
}

export const RECOMMEND_BLOCKS: Block[] = [
    {
        title: 'Menu',
        subTitle: 'Link to your digital menu.',
        image: ThumbnailBlock,
        forGrowAccount: true,
        name: 'Menu',
        nodeData: {} as SerializedNode,
        limits: 1,
    },
    {
        title: 'Contact & Location',
        subTitle: 'Display quick contact information.',
        icon: <Contact />,
        forGrowAccount: false,
        isReady: true,
        name: 'Contact',
        limits: 1,
        nodeData: {
            type: {
                resolvedName: 'Contact',
            },
            displayName: 'Contact',
            custom: {
                showBox: true,
            },
            parent: 'ROOT',
            hidden: false,
            nodes: [],
            linkedNodes: {},
            props: {},
        },
    },
    {
        title: 'Opening Hours',
        subTitle: 'Display your business opening hours.',
        icon: <ClockIcon />,
        forGrowAccount: false,
        isReady: true,
        name: 'OpeningHours',
        limits: 1,
        nodeData: {
            type: {
                resolvedName: 'OpeningHours',
            },
            displayName: 'Opening Hours',
            custom: {
                showBox: true,
            },
            parent: 'ROOT',
            hidden: false,
            nodes: [],
            linkedNodes: {},
            props: {
                hideDay: {},
            },
        },
    },
    {
        title: 'Ordering Link',
        subTitle: 'Link to your ordering and delivery partners.',
        icon: <OrderLink />,
        forGrowAccount: false,
        isReady: true,
        name: 'OrderLink',
        limits: 1,
        nodeData: {
            type: {
                resolvedName: 'OrderLink',
            },
            displayName: 'Order Link',
            custom: {
                showBox: false,
            },
            parent: 'ROOT',
            hidden: false,
            nodes: [],
            linkedNodes: {},
            props: {},
        },
    },
    {
        title: 'Booking Link',
        subTitle: 'Link to your booking service.',
        icon: <Booking />,
        forGrowAccount: false,
        isReady: false,
        limits: 1,
        name: 'BookingLink',
        nodeData: {} as SerializedNode,
    },
];

export const MORE_BLOCKS: Block[] = [
    {
        title: 'Custom Link',
        subTitle: 'Link to a custom URL.',
        icon: <Link1 />,
        forGrowAccount: false,
        isReady: true,
        name: 'CustomLink',
        limits: 0,
        nodeData: {
            type: {
                resolvedName: 'CustomLink',
            },
            displayName: 'Custom Link',
            custom: {
                showBox: false,
            },
            parent: 'ROOT',
            hidden: false,
            nodes: [],
            linkedNodes: {},
            props: {},
        },
    },
    {
        title: 'Image Gallery',
        subTitle: 'Showcase images of your business.',
        icon: (
            <div className="text-18">
                <ImageIcon />
            </div>
        ),
        isReady: true,
        name: 'ImageGallery',
        nodeData: {
            type: {
                resolvedName: 'ImageGallery',
            },
            displayName: 'ImageGallery',
            custom: {
                showBox: false,
            },
            parent: 'ROOT',
            hidden: false,
            nodes: [],
            linkedNodes: {},
            props: {
                images: [],
                title: '',
                showTitle: true,
            },
        },
        limits: 1,
    },
];
